import {WorkerActions} from '@/workers/workerActions';

import {boostAppearHandler} from './boostAppearHandler';
import {boostDeletedHandler} from './boostDeletedHandler';
import {boostMeHandler} from './boostMeHandler';
import {clearMyBoostHandler} from './clearMyBoostHandler';

const handledActions = [WorkerActions.SocketMessage];

const handlers: Record<string, Record<string, (model: any) => void>> = {
  boost: {
    appear: boostAppearHandler,
    deleted: boostDeletedHandler,
    removed: boostDeletedHandler,
  },
  'boost.me': {
    created: boostMeHandler,
    deleted: clearMyBoostHandler,
  },
  'me.boost': {
    expired: clearMyBoostHandler,
  },
};

export const handleBoostEvent = (event: MessageEvent) => {
  const {action: sharedWorkerAction, data} = event.data;

  if (!handledActions.includes(sharedWorkerAction)) {
    return;
  }

  const {res, action, model}: {res: string; action: string; model: unknown} =
    data;
  handlers[res]?.[action]?.(model);
};
